module.exports = __webpack_public_path__ + "static/media/TP_Icon_StressBall.7b5a6fda.png";